import { motion } from "framer-motion";
export default function KarmaFooter() {
  return (
    <>
      <motion.p
        className="absolute bottom-5 text-xl font-bold uppercase tracking-wide mt-4 flex items-center justify-center gap-2"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{
          background:
            "linear-gradient(135deg, hsl(200, 100%, 80%) 0%, hsl(220, 100%, 70%) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          filter: "drop-shadow(0 0 10px hsl(220, 100%, 60%))",
        }}
      >
        TYPE{" "}
        <img
          src="/espont.png"
          alt="espont"
          className="inline-block h-6 w-6"
          style={{ filter: "drop-shadow(0 0 8px hsl(220, 100%, 60%))" }}
        />
        IN CHAT TO PARTICIPATE
      </motion.p>
    </>
  );
}
